import LocalizedStrings from "localized-strings";
import { strings_en } from "./LocalizedStrings.en";
import { strings_es } from "./LocalizedStrings.es";

export const strings = new LocalizedStrings({
  en: strings_en,
  es: strings_es
});
